const Skeleton = ({ className = "", variant = "rect" }) => {
  const base = "animate-pulse bg-[#E4DFD3] rounded-xl";
  if (variant === "circle")
    return <div className={`${base} rounded-full ${className}`} />;
  if (variant === "text")
    return <div className={`${base} h-4 ${className}`} />;
  return <div className={`${base} ${className}`} />;
};

export const CardSkeleton = () => (
  <div className="bg-white border border-[#E4DFD3] rounded-2xl p-6 space-y-4">
    <Skeleton className="w-12 h-12" variant="circle" />
    <Skeleton className="h-5 w-3/4" variant="text" />
    <Skeleton className="h-4 w-1/2" variant="text" />
    <Skeleton className="h-10 w-full mt-4" />
  </div>
);

export const ListSkeleton = ({ count = 3 }) => (
  <div className="space-y-3">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-white border border-[#E4DFD3] rounded-xl p-4 flex items-center gap-4">
        <Skeleton className="w-10 h-10 shrink-0" variant="circle" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-2/3" variant="text" />
          <Skeleton className="h-3 w-1/3" variant="text" />
        </div>
      </div>
    ))}
  </div>
);

export const GridSkeleton = ({ count = 6 }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    {Array.from({ length: count }).map((_, i) => (
      <CardSkeleton key={i} />
    ))}
  </div>
);

export default Skeleton;
